import React from "react";
import Spinner from "../LoadingSpinner";
import { Paragraph } from "../../Elements/Paragraph";

import style from "./LoadingScreen.module.css";

type LoadingScreenProps = {
  text?: string;
  loading: boolean;
  children: React.ReactNode;
  transparentMode?: boolean;
};

function LoadingScreen({ children, loading, text, transparentMode }: LoadingScreenProps): JSX.Element {
  if (loading) {

    if (transparentMode) {
      return (
        <>
          {children}
          <div className={style.loadingTransparent}>
              <Spinner />
              {text && <Paragraph className={style.text}>{text}</Paragraph>}
          </div>
        </>
      );
    }

    return (
      <div className={style.loading}>
          <Spinner />
          {text && <Paragraph className={style.text}>{text}</Paragraph>}
      </div>
    );
  }

  return <>{children}</>;
}

export default LoadingScreen;
